import _ from 'lodash';

import React from 'react';
import classNames from 'classnames';
import {default as ReactSelect} from 'react-select';

import {
  Arrow,
  HousekeepingStatusOption,
  HousekeepingSelectedValue
} from './components';
import {CLEANING_STATUSES} from 'ducks/allocations';

import './styles.css';
import 'react-select/dist/react-select.css';

class HousekeepingStatusSelect extends React.Component<any> {
  optionRenderer = option => {
    return <HousekeepingStatusOption option={option} />;
  };
  arrowRenderer = () => <Arrow />;

  render() {
    const {value, className, onChange, disabled} = this.props;

    return (
      <div className={classNames(className, 'HousekeepingStatusSelect')}>
        <ReactSelect
          className="ReactSelect"
          value={value}
          options={CLEANING_STATUSES}
          searchable={false}
          clearable={false}
          onChange={onChange}
          arrowRenderer={this.props.arrowRenderer || this.arrowRenderer}
          optionRenderer={this.optionRenderer}
          valueRenderer={this.optionRenderer}
          valueComponent={HousekeepingSelectedValue}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default HousekeepingStatusSelect;
